import React from "react";
import { Archive, Calendar, UserCheck, Users } from "lucide-react";

// The five bottom statistics cards (Total / Active / OnLeave / Archived / Recent)
const StatCardsGrid = ({
  styles,
  text,
  language,
  theme,
  screenSize,
  fonts,
  spacing,
  gridCols,
  employeeCount,
  counts,
  archivedCount,
}) => {
  const cardTitleStyle = {
    color: theme === "dark" ? "white" : "#1a1a1a",
    margin: `0 0 ${screenSize === "xs" ? "0.5rem" : "0.5rem"} 0`,
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    fontSize: fonts.body,
    flexWrap: screenSize === "xs" ? "wrap" : "nowrap",
  };

  const cardValueStyle = (color) => ({
    color,
    fontSize: screenSize === "xs" ? "1.5rem" : "1.5rem",
    fontWeight: "700",
    margin: 0,
  });

  const cardSubtitleStyle = {
    color:
      theme === "dark"
        ? "rgba(255, 255, 255, 0.6)"
        : "rgba(26, 26, 26, 0.6)",
    fontSize: fonts.tiny,
    margin: "0.25rem 0 0 0",
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${gridCols}, 1fr)`,
        gap: spacing.gap,
        marginTop: spacing.margin,
      }}
    >
      {/* Total Employees Card */}
      <div style={styles.statCard}>
        <h4 style={cardTitleStyle}>
          <Users size={screenSize === "xs" ? 14 : 16} />
          {screenSize === "xs"
            ? text[language].total
            : text[language].totalEmployees}
        </h4>
        <p style={cardValueStyle("#10b981")}>
          {employeeCount}
        </p>
        <p style={cardSubtitleStyle}>
          {screenSize === "xs"
            ? text[language].allEmployees
            : text[language].allRegisteredEmployees}
        </p>
      </div>

      {/* Active Employees Card */}
      <div style={styles.statCard}>
        <h4 style={cardTitleStyle}>
          <UserCheck size={screenSize === "xs" ? 14 : 16} />
          {screenSize === "xs"
            ? text[language].active
            : text[language].activeEmployees}
        </h4>
        <p style={cardValueStyle("#10b981")}>
          {counts.Active}
        </p>
        <p style={cardSubtitleStyle}>
          {text[language].currentlyWorking}
        </p>
      </div>

      {/* On Leave Card */}
      <div style={styles.statCard}>
        <h4 style={cardTitleStyle}>
          <Calendar size={screenSize === "xs" ? 14 : 16} />
          {text[language].onLeave}
        </h4>
        <p style={cardValueStyle("#f59e0b")}>
          {counts.OnLeave}
        </p>
        <p style={cardSubtitleStyle}>
          {text[language].currentlyOnLeave}
        </p>
      </div>

      {/* Archived Card */}
      <div style={styles.statCard}>
        <h4 style={cardTitleStyle}>
          <Archive size={screenSize === "xs" ? 14 : 16} />
          {text[language].archived}
        </h4>
        <p style={cardValueStyle("#f59e0b")}>
          {archivedCount}
        </p>
        <p style={cardSubtitleStyle}>
          {text[language].archivedEmployees}
        </p>
      </div>

      {/* Recent Employees Card */}
      <div style={styles.statCard}>
        <h4 style={cardTitleStyle}>
          <Calendar size={screenSize === "xs" ? 14 : 16} />
          {text[language].newEmployees}
        </h4>
        <p style={cardValueStyle("#f59e0b")}>
          {counts.Recent}
        </p>
        <p style={cardSubtitleStyle}>
          {text[language].joinedRecently}
        </p>
      </div>
    </div>
  );
};

export default StatCardsGrid;
